import { translations } from '@labsavvyapp/ui-components'

export const en = {
  ...translations.en,
}
